var React = require('react');

function PlusOrMinus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 15a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2H4zM7 5V2a1 1 0 1 1 2 0v3h3a1 1 0 0 1 0 2H9v3a1 1 0 0 1-2 0V7H4a1 1 0 1 1 0-2h3z"}));
}

PlusOrMinus.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = PlusOrMinus;

PlusOrMinus.default = PlusOrMinus;
